import React from "react";

// Legacy config.color names map onto the status tokens: a dot, not a full-bleed fill.
const DOT = {
  green: "var(--vx-ok)",
  blue: "var(--vx-accent)",
  orange: "var(--vx-warn)",
  yellow: "var(--vx-warn)",
  red: "var(--vx-danger)",
  purple: "var(--vx-anomaly)",
  gray: "var(--vx-idle)",
};

export default function StatusCardWidget({ title, value, unit, color = "green", icon, subtitle }) {
  return (
    <div style={styles.card}>
      <div style={styles.head}>
        <span style={{ ...styles.dot, background: DOT[color] || DOT.green }} aria-hidden="true" />
        {icon && <span style={styles.icon}>{icon}</span>}
        <span style={styles.title} title={title}>{title}</span>
      </div>
      <div style={styles.value}>
        {value}
        {unit && <span style={styles.unit}>{unit}</span>}
      </div>
      {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
    </div>
  );
}

const styles = {
  card: {
    height: "100%",
    boxSizing: "border-box",
    padding: "10px 14px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "6px",
    overflow: "hidden",
    background: "var(--vx-surface)",
    fontFamily: "var(--vx-font-sans)",
  },
  head: { display: "flex", alignItems: "center", gap: "8px", minWidth: 0 },
  dot: { width: "8px", height: "8px", borderRadius: "50%", flexShrink: 0 },
  icon: { fontSize: "14px", flexShrink: 0 },
  title: {
    fontSize: "12px",
    fontWeight: 600,
    color: "var(--vx-text-2)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  value: {
    fontFamily: "var(--vx-font-mono)",
    fontSize: "22px",
    fontWeight: 500,
    lineHeight: 1.1,
    color: "var(--vx-text)",
    whiteSpace: "nowrap",
  },
  unit: { fontSize: "12px", marginLeft: "4px", color: "var(--vx-text-2)", fontWeight: 400 },
  subtitle: { fontSize: "11px", color: "var(--vx-text-2)" },
};
